import { ref } from 'vue'

// Global state for cancel hire modal
const showCancelHireModal = ref(false)

export function useCancelHireModal() {
  const openCancelHireModal = () => {
    showCancelHireModal.value = true
  }

  const closeCancelHireModal = () => {
    showCancelHireModal.value = false
  }

  return {
    showCancelHireModal,
    openCancelHireModal,
    closeCancelHireModal,
  }
}
